var React = require('react');

function Bat (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M411.83 175.3L320 230.4l-91.83-55.1L256 64l42.66 32h42.67L384 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M640 320l-49.63-16.54a64 64 0 0 0-73.49 25.21L480 384l-11.82-11.82a64 64 0 0 0-90.51 0 65.74 65.74 0 0 0-5.95 6.86L320 448l-51.72-69a64 64 0 0 0-89.6-12.8 64.73 64.73 0 0 0-6.86 5.95L160 384l-36.89-55.33a64 64 0 0 0-73.49-25.21L0 320l81.55-190.31a32 32 0 0 1 42-16.8 32.58 32.58 0 0 1 3.86 2L320 230.4l192.56-115.53a32 32 0 0 1 43.91 11 32.58 32.58 0 0 1 2 3.86z","className":"fa-primary","key":2})]);
}

Bat.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Bat;

Bat.default = Bat;
